module.exports = __webpack_public_path__ + "img/sa3.319a26cc.png";